import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { Card } from '@/components/ui/card';

import type { LucideIcon } from 'lucide-react';

type AppTypeCardProps = {
  value: string;
  icon: LucideIcon;
  title: string;
  description: string;
};

const AppTypeCard = ({ value, icon: Icon, title, description }: AppTypeCardProps) => (
  <RadioGroupPrimitive.Item
    value={value}
    className="group space-y-3 rounded-lg p-5 transition-colors hover:border-slate-400 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring data-[state=checked]:bg-[color-mix(in_srgb,var(--color-accent-software-escrow)_6%,#fff)] data-[state=checked]:shadow-[0_0_0_1px_var(--color-accent-software-escrow)] data-[state=checked]:border-accent-software-escrow cursor-pointer"
    asChild
  >
    <Card className="shadow-none">
      <span className="flex size-10 items-center justify-center rounded-md bg-muted text-slate-700 group-data-[state=checked]:bg-accent-software-backup group-data-[state=checked]:text-white">
        <Icon className="size-5" />
      </span>
      <div className="space-y-1">
        <h6 className="text-sm font-extrabold">{title}</h6>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
    </Card>
  </RadioGroupPrimitive.Item>
);

export default AppTypeCard;
